module.exports = __webpack_public_path__ + "static/media/SF-11-A.67a656b0.mp3";